import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import _ from 'lodash';
import classnames from 'classnames';

class ToggleInputSimple extends React.PureComponent {

    static propTypes = {
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([
            PropTypes.string.isRequired,
            PropTypes.object.isRequired
        ]),
        field: PropTypes.string,
        labelClassName: PropTypes.string,
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        disableInputOnly: PropTypes.bool,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        className: PropTypes.string,
        index: PropTypes.number,
        isJourneySupport: PropTypes.bool,
        title: PropTypes.string,
        titleId: PropTypes.string,
        isHalfOnState: PropTypes.bool,
        infoId: PropTypes.string,
        southeasternId: PropTypes.string,
    };

    static defaultProps = {
        value: '',
        label: '',
        field: '',
        labelClassName: '',
        defaultChecked: true,
        onChange: _.noop,
        onClick: _.noop,
        className: '',
        disabled: false,
        disableInputOnly: false,
        isJourneySupport: false,
        title: '',
        titleId: '',
    };

    state = {
        checked: !!this.props.checked
    };

    UNSAFE_componentWillReceiveProps (newProps) {
        if (newProps.checked !== this.props.checked) {
            this.setState({ checked: !!newProps.checked });
        }
    }

    _handleChange = () => {
        const { checked } = this.state;
        const { field, index } = this.props;

        const dynamicArguments = () => {
            /* passing field name, toggle status and index of the element if necessary
            (used for photocards, but it can be useful for other iterable element). */
            if (this.props.field) {
                return [
                    field,
                    !checked,
                    index,
                ];
            } else {
                return !checked;
            }
        };

        if (!this.props.disabled) {
            this.setState({ checked: !checked }, this.props.onChange.bind(null, ...dynamicArguments()));
        }
    };

    render () {
        const { 
            id, 
            value, 
            label, 
            labelClassName, 
            className, 
            disabled, 
            disableInputOnly, 
            onClick,
            isJourneySupport,
            title,
            titleId,
            isHalfOnState,
            infoId,
            southeasternId
        } = this.props;

        const { checked } = this.state;
        const containerClasses = classnames(className, 'clearfix', 'toggle-simple', {
            'toggle-simple--checked': checked,
            'toggle-simple--disabled': disabled && !disableInputOnly,
            'toggle-simple--half': isHalfOnState
        });
        const toggleClasses = classnames('toggle-simple__lane pull-left', {
            'journey-support': isJourneySupport
        })
        const toggleStateClasses = classnames('toggle-simple__handle', {
            'half-state': isHalfOnState
        })

        return (
            <Fragment>
                <div className={ containerClasses }>
                    <title className="sr-only" id={ titleId }>{ title }</title>
                    <input type="checkbox"
                        id={ southeasternId ? southeasternId : id }
                        className={ classnames({ 'toggle-simple--disabled': disabled && disableInputOnly }) }
                        name={ value }
                        disabled={ disabled }
                        defaultChecked={ checked }
                        onChange={ this._handleChange }
                        onClick={ onClick } 
                        aria-describedby={ isHalfOnState ? infoId : titleId }
                        aria-checked={ checked } 
                        aria-label={ title } />
                    <div className="toggle-simple-inner-wrapper">
                        <div className={toggleClasses}>
                            <div className={toggleStateClasses} />
                        </div>

                        <label htmlFor={ southeasternId ? southeasternId : id } className={ labelClassName }>
                            { label }
                        </label>
                    </div>
                </div>
            </Fragment>
        );
    }

}

export default ToggleInputSimple;



// WEBPACK FOOTER //
// ./src/components/form/ToggleInputSimple.js